<template>
  <f7-page name="oeb-config" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back icon-f7="arrow_left"></f7-link>
        <div class="btn-info" @click.stop="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) inicializarInst()" :class="{'btn-info-activo': popupInfo}"><span>i</span></div>
      </f7-nav-left>
      <f7-nav-title>Configuración OEB — Producción</f7-nav-title>
    </f7-navbar>
    <!-- #16 · Objetivos y personas: lectura directa de su coleccion. -->
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
      <!-- SELECTOR DE AÑO + RESUMEN + ACCIONES en zona compacta -->
      <div class="mes-selector">
        <f7-link @click="anioSeleccionado--; cambiarAnio(anioSeleccionado)" icon-f7="chevron_left"></f7-link>
        <span class="mes-nombre">{{ anioSeleccionado }}</span>
        <f7-link @click="anioSeleccionado++; cambiarAnio(anioSeleccionado)" icon-f7="chevron_right"></f7-link>
      </div>

      <!-- RESUMEN RÁPIDO -->
      <div class="resumen-bar" v-if="personas.length">
        <div class="resumen-item"><span class="resumen-num">{{ personasActivas }}</span><span class="resumen-label">Activas <info-icon dominio="oeb" clave="OEB_ConfigActivas" criticidad="CRITICO" pantalla="configuracion-oeb" /></span></div>
        <div class="resumen-item"><span class="resumen-num">{{ formatImporte(objDiarioTotal) }}</span><span class="resumen-label">Obj/día equipo <info-icon dominio="oeb" clave="OEB_ConfigObjDiaEquipo" criticidad="CRITICO" pantalla="configuracion-oeb" /></span></div>
      </div>

      <!-- ACCIONES GLOBALES -->
      <div class="acciones-config">
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small fill color="blue" @click="aplicarFactor">Aplicar factor</f7-button>
          <info-icon dominio="oeb" clave="OEB_ConfigAplicarFactor" criticidad="CRITICO" pantalla="configuracion-oeb" @click.native.stop />
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small fill color="green" @click="nuevaPersona">+ Persona</f7-button>
          <info-icon dominio="oeb" clave="OEB_ConfigAnadirPersona" criticidad="CRITICO" pantalla="configuracion-oeb" @click.native.stop />
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small fill color="purple" @click="nuevosObjetivos">Nuevos objetivos</f7-button>
          <info-icon dominio="oeb" clave="OEB_ConfigNuevosObjetivos" criticidad="CRITICO" pantalla="configuracion-oeb" @click.native.stop />
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small outline @click="migrarDesdeConfig">Migrar config → {{ anio }}</f7-button>
          <info-icon dominio="oeb" clave="OEB_ConfigMigrar" criticidad="CRITICO" pantalla="configuracion-oeb" @click.native.stop />
        </span>
      </div>

      <!-- TABLA DE PERSONAS -->
      <div class="tabla-config-scroll" v-if="personas.length">
        <table class="tabla-config">
          <thead>
            <tr>
              <th class="col-codigo">Código <info-icon dominio="oeb" clave="OEB_ConfigCodigo" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-nombre">Nombre <info-icon dominio="oeb" clave="OEB_ConfigNombre" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-num">Obj.Base <info-icon dominio="oeb" clave="OEB_ConfigObjBase" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-num">Factor <info-icon dominio="oeb" clave="OEB_ConfigFactor" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-num">Obj.Actual <info-icon dominio="oeb" clave="OEB_ConfigObjActual" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-activo">Activo <info-icon dominio="oeb" clave="OEB_ConfigActivo" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
              <th class="col-acciones">Acciones <info-icon dominio="oeb" clave="OEB_ConfigEliminarPersona" criticidad="CRITICO" pantalla="configuracion-oeb" /></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in personas" :key="p.codigoPersonal" :class="{'fila-inactiva': !p.activo}">
              <td class="col-codigo"><strong>{{ p.codigoPersonal }}</strong></td>
              <td class="col-nombre">
                <input type="text" v-model="p.nombre" class="input-inline" />
              </td>
              <td class="col-num">
                <input type="number" v-model.number="p.objetivoDiarioBase" class="input-num" step="1" min="0" @input="recalcActual(p)" />
              </td>
              <td class="col-num">
                <input type="number" v-model.number="p.factorIncremento" class="input-num input-factor" step="0.01" min="0" @input="recalcActual(p)" />
              </td>
              <td class="col-num">
                <input type="number" v-model.number="p.objetivoDiarioActual" class="input-num" step="1" min="0" />
              </td>
              <td class="col-activo">
                <label class="toggle-mini">
                  <input type="checkbox" v-model="p.activo" />
                  <span>{{ p.activo ? 'Sí' : 'No' }}</span>
                </label>
              </td>
              <td class="col-acciones">
                <button class="btn-guardar" @click="guardarPersona(p)">Guardar</button>
                <button class="btn-eliminar" @click="eliminarPersona(p)">×</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- LOADING -->
      <f7-block v-if="cargando" class="text-align-center">
        <f7-preloader></f7-preloader>
      </f7-block>
    </f7-page-content>

    <!-- MENSAJE SECCIÓN RESTRINGIDA (solo se muestra si NO es Grupo A) -->
    <f7-page-content v-noroles="['ADMIN','DIRECTOR','DTYCAL']">
      <div style="padding:40px 20px;text-align:center;color:#64748b">
        <div style="font-size:48px;margin-bottom:20px">🔒</div>
        <div style="font-size:18px;font-weight:600;color:#1a2744;margin-bottom:12px">Sección restringida</div>
        <div style="font-size:14px;line-height:1.6;max-width:400px;margin:0 auto">
          Esta sección permite editar objetivos anuales. Solo disponible para roles de administración.
        </div>
      </div>
    </f7-page-content>

    <!-- POPUP GUÍA DE USO -->
    <f7-popup :opened="popupInfo" @popup:close="fullscreen = false; popupInfo = false" class="ct-popup" :style="fullscreen ? '--f7-popup-tablet-width:95vw;--f7-popup-tablet-height:95vh' : ''">
      <f7-page :page-content="false">
        <f7-navbar title="Guía de uso" style="display:none"></f7-navbar>
        <div class="ct-hdr" style="background:linear-gradient(135deg,#0F6E56,#27ae80)">
          <div class="ct-hdr-top">
            <div class="ct-hdr-left">
              <span class="ct-hdr-ico">⚙️</span>
              <div><div class="ct-hdr-title">Guía de uso</div><div class="ct-hdr-sub">CONFIGURACIÓN OEB</div></div>
            </div>
            <div class="ct-hdr-right">
              <span class="ct-hdr-badge">{{ instFiltradas.length }} instrucciones</span>
              <button class="ct-hdr-add" @click="nuevaInst">+</button>
              <button class="ct-hdr-close" @click="fullscreen = !fullscreen">{{ fullscreen ? '⇖' : '⛶' }}</button>
              <button class="ct-hdr-close" @click="fullscreen = false; popupInfo = false">✕</button>
            </div>
          </div>
          <div class="ct-search-wrap">
            <span class="ct-search-ico">🔍</span>
            <input class="ct-search" type="text" placeholder="Buscar instrucciones..." v-model="busquedaInst">
            <button v-if="busquedaInst" class="ct-search-x" @click="busquedaInst = ''">✕</button>
          </div>
        </div>
        <f7-page-content class="ct-body">
          <div v-if="instFiltradas.length" class="ct-counter">{{ instFiltradas.length }} instrucciones</div>
          <div v-if="!instFiltradas.length" class="ct-empty"><span style="font-size:32px;opacity:.3">⚙️</span><p>Sin instrucciones. Pulsa + para crear.</p></div>
          <div v-for="(inst, idx) in instFiltradas" :key="inst.id" class="ct-card" style="border-left-color:#0F6E56"
            draggable="true" @dragstart="draggingInst = idx" @dragover.prevent @drop="dropInst(idx)">
            <div class="ct-card-hdr" @click="expandedInst === inst.id ? expandedInst = null : expandedInst = inst.id">
              <span class="ct-card-num" style="background:#0F6E56">{{ idx + 1 }}</span>
              <div class="ct-card-title-area"><div class="ct-card-title">{{ inst.titulo }}</div></div>
              <span class="ct-card-chev">{{ expandedInst === inst.id ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedInst === inst.id" class="ct-card-body">
              <template v-if="inst._editando">
                <div class="ct-form-field"><label>Título</label><input type="text" v-model="inst.titulo"></div>
                <div class="ct-form-field"><label>Contenido</label><textarea v-model="inst.texto" rows="4"></textarea></div>
                <div class="ct-form-btns">
                  <button class="ct-fbtn ct-fbtn-ok" @click="guardarInst(inst)">Guardar</button>
                  <button class="ct-fbtn ct-fbtn-cancel" @click="inst._editando = false">Cancelar</button>
                </div>
              </template>
              <template v-else>
                <div class="ct-card-content">{{ inst.texto }}</div>
                <div class="ct-card-actions">
                  <button @click.stop="$set(inst, '_editando', true)">✏️ Editar</button>
                  <button @click.stop="eliminarInst(inst)">🗑️ Eliminar</button>
                </div>
              </template>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
/* Selector año */
.mes-selector { display:flex; align-items:center; justify-content:center; gap:0.8em; padding:0.3em 0.6em 0.2em; }
.mes-nombre { font-size:1.4em; font-weight:700; color:#1a2744; letter-spacing:-0.02em; }

/* Resumen */
.resumen-bar { display:flex; gap:6px; padding:4px 8px; flex-wrap:wrap; align-items:center; }
.resumen-item { background:linear-gradient(135deg,#fff,#f8fafe); border:1px solid #e8edf3; border-radius:6px; padding:3px 10px; text-align:center; }
.resumen-num { display:block; font-size:14px; font-weight:700; color:#1a2744; }
.resumen-num.gc { color:#E65100; }
.resumen-num.fv { color:#1565C0; }
.resumen-num.ic { color:#4527A0; }
.resumen-label { font-size:9px; color:#7c8db0; text-transform:uppercase; letter-spacing:0.04em; font-weight:600; }

/* Acciones */
.acciones-config { display:flex; gap:6px; padding:2px 8px 6px; flex-wrap:wrap; }

/* Tabla */
.tabla-config-scroll { overflow-x:auto; margin:0 8px; border:1px solid #dde3ed; border-radius:8px; box-shadow:0 1px 6px rgba(0,0,0,0.04); }
.tabla-config { width:100%; border-collapse:collapse; font-size:12px; white-space:nowrap; }
.tabla-config thead th { background:#1a2744; color:#c8d3e5; padding:8px 6px; font-weight:600; font-size:10px; text-transform:uppercase; letter-spacing:0.04em; text-align:left; }
.tabla-config tbody td { padding:4px 6px; border-bottom:1px solid #eef0f5; vertical-align:middle; }
.tabla-config tbody tr:nth-child(even) { background:#fafbfd; }
.tabla-config tbody tr:hover { background:#eef2f9; }
.fila-inactiva { opacity:0.45; }

/* Columnas */
.col-codigo { min-width:60px; font-weight:700; color:#1a2744; }
.col-nombre { min-width:120px; }
.col-cls { min-width:60px; }
.col-num { min-width:80px; text-align:right; }
.col-activo { min-width:50px; text-align:center; }
.col-acciones { min-width:100px; }

/* Inputs inline */
.input-inline { width:100%; padding:3px 6px; border:1px solid #dde3ed; border-radius:4px; font-size:12px; background:#fff; }
.input-inline:focus { border-color:#1565C0; outline:none; }
.input-num { width:70px; padding:3px 4px; border:1px solid #dde3ed; border-radius:4px; font-size:12px; text-align:right; background:#fff; }
.input-num:focus { border-color:#1565C0; outline:none; }
.input-factor { width:55px; }


/* Toggle */
.toggle-mini { font-size:11px; cursor:pointer; }
.toggle-mini input { margin-right:4px; }

/* Botones */
.btn-guardar { padding:3px 10px; background:#0E6251; color:white; border:none; border-radius:4px; font-size:10px; font-weight:600; cursor:pointer; }
.btn-guardar:hover { background:#0a4f42; }
.btn-eliminar { padding:3px 8px; background:none; color:#B71C1C; border:1px solid #FADBD8; border-radius:4px; font-size:12px; font-weight:700; cursor:pointer; margin-left:4px; }
.btn-eliminar:hover { background:#FADBD8; }

/* Botón info + Popup guía */
.btn-info { width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;cursor:pointer;border:1.5px solid #5DCAA5; }
.btn-info span { color:#5DCAA5;font-size:13px;font-weight:500;font-style:italic; }
.btn-info-activo { background:#5DCAA5 !important; }
.btn-info-activo span { color:#1a2744 !important; }
.ct-popup { --f7-popup-tablet-width:700px; }
.ct-hdr { padding:14px 16px 12px;flex-shrink:0; }
.ct-hdr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:12px; }
.ct-hdr-left { display:flex;align-items:center;gap:10px; }
.ct-hdr-ico { font-size:24px; }
.ct-hdr-title { font-size:16px;font-weight:800;color:#fff; }
.ct-hdr-sub { font-size:10px;color:rgba(255,255,255,.6);margin-top:1px; }
.ct-hdr-right { display:flex;align-items:center;gap:6px; }
.ct-hdr-badge { background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff; }
.ct-hdr-add,.ct-hdr-close { width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.ct-hdr-add:hover,.ct-hdr-close:hover { background:rgba(255,255,255,.25); }
.ct-search-wrap { position:relative;display:flex;align-items:center; }
.ct-search-ico { position:absolute;left:10px;font-size:13px; }
.ct-search { width:100%;padding:9px 32px;border:none;border-radius:8px;font-size:13px;background:rgba(255,255,255,.9);color:#1e293b;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.1); }
.ct-search:focus { background:#fff; }
.ct-search-x { position:absolute;right:8px;background:none;border:none;color:#94a3b8;font-size:12px;cursor:pointer;padding:4px; }
.ct-body { background:linear-gradient(180deg,#f8fafc,#f0f2f5);padding:10px 14px !important; }
.ct-counter { font-size:11px;color:#64748b;font-weight:600;padding:4px 2px 8px; }
.ct-empty { text-align:center;padding:40px 20px;color:#94a3b8;font-size:12px; }
.ct-card { background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.05);overflow:hidden;cursor:grab; }
.ct-card:hover { box-shadow:0 3px 10px rgba(0,0,0,.08); }
.ct-card-hdr { display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer; }
.ct-card-num { width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;color:#fff;flex-shrink:0; }
.ct-card-title-area { flex:1;min-width:0; }
.ct-card-title { font-size:13px;font-weight:600;color:#1e293b;line-height:1.4; }
.ct-card-chev { font-size:10px;color:#94a3b8;flex-shrink:0; }
.ct-card-body { padding:0 12px 12px;border-top:1px solid #f1f5f9; }
.ct-card-content { font-size:12.5px;line-height:1.6;color:#334155;padding:10px 4px; }
.ct-card-actions { display:flex;gap:4px;padding-top:8px;border-top:1px solid #f1f5f9; }
.ct-card-actions button { background:none;border:1px solid #e2e8f0;border-radius:6px;padding:4px 10px;font-size:10px;cursor:pointer;color:#475569; }
.ct-card-actions button:hover { background:#f1f5f9; }
.ct-form-field { display:flex;flex-direction:column;gap:3px;margin-bottom:8px; }
.ct-form-field label { font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase; }
.ct-form-field input,.ct-form-field textarea { padding:8px 10px;border:1.5px solid #d1d9e0;border-radius:6px;font-size:12px;font-family:inherit;color:#1e293b;outline:none;resize:vertical; }
.ct-form-field input:focus,.ct-form-field textarea:focus { border-color:#0F6E56; }
.ct-form-btns { display:flex;gap:6px; }
.ct-fbtn { padding:7px 16px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit; }
.ct-fbtn-ok { background:#0F6E56;color:#fff; }
.ct-fbtn-ok:hover { background:#0a4f42; }
.ct-fbtn-cancel { background:#f1f5f9;color:#475569;border:1px solid #e2e8f0; }
.ct-fbtn-cancel:hover { background:#e2e8f0; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import InfoIcon from '../../components/InfoIcon.vue';
import SelloDatos from '../../components/SelloDatos.vue';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

export default {
  components: { InfoIcon, SelloDatos },
  data() {
    return {
      anio: new Date().getFullYear(),
      anioSeleccionado: new Date().getFullYear(),
      personas: [],
      cargando: false,
      popupInfo: false,
      fullscreen: false,
      instrucciones: [],
      busquedaInst: '',
      expandedInst: null,
      draggingInst: null,
    };
  },
  computed: {
    instFiltradas: function() {
      var q = (this.busquedaInst || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) { return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1; });
    },
    personasActivas() { return this.personas.filter(function(p) { return p.activo; }).length; },
    objDiarioTotal() { return this.personas.filter(function(p) { return p.activo; }).reduce(function(s, p) { return s + (p.objetivoDiarioActual || 0); }, 0); },
  },
  methods: {
    onPageInit() { this.cargarPersonas(); this.cargarInstrucciones(); },
    cambiarAnio(a) { this.anio = a; this.anioSeleccionado = a; this.cargarPersonas(); },
    cargarPersonas() {
      var self = this;
      // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que lo soltaba.
      cerrojoDeLaSesion(self, 'cargando');
      Oeb.getObjetivosAnio(self.anio).then(function(res) {
        self.personas = unwrapDto(res) || [];
        self.cargando = false;
      }).catch(function() { self.cargando = false; });
    },
    recalcActual(p) {
      var base = p.objetivoDiarioBase || 0;
      var factor = p.factorIncremento || 1.0;
      p.objetivoDiarioActual = Math.round(base * factor * 100) / 100;
    },
    guardarPersona(p) {
      var self = this;
      Oeb.guardarObjetivo(self.anio, p.codigoPersonal, {
        objetivoDiarioBase: p.objetivoDiarioBase,
        factorIncremento: p.factorIncremento,
        objetivoDiarioActual: p.objetivoDiarioActual,
        activo: p.activo
      }).then(function(res) {
        if (unwrapDto(res)) {
          self.$f7.toast.create({ text: p.codigoPersonal + ' guardado (' + self.anio + ')', position: 'top', closeTimeout: 1500 }).open();
        }
      });
    },
    eliminarPersona(p) {
      var self = this;
      self.$f7.dialog.confirm('¿Desactivar ' + p.codigoPersonal + '?', 'Confirmar', function() {
        Oeb.eliminarPersona(p.codigoPersonal).then(function() {
          self.cargarPersonas();
        });
      });
    },
    nuevaPersona() {
      var self = this;
      self.$f7.dialog.prompt('Código de la persona:', 'Nueva persona', function(codigo) {
        if (!codigo) return;
        var cod = codigo.trim().toUpperCase();
        Oeb.guardarObjetivo(self.anio, cod, {
          objetivoDiarioBase: 0,
          factorIncremento: 1.06,
          activo: true
        }).then(function() { self.cargarPersonas(); });
      });
    },
    aplicarFactor() {
      var self = this;
      self.$f7.dialog.prompt('Factor de incremento para ' + self.anio + ':', 'Aplicar factor', function(val) {
        var factor = parseFloat(val);
        if (isNaN(factor) || factor <= 0) return;
        Oeb.aplicarFactorObjetivos(self.anio, factor).then(function(res) {
          if (unwrapDto(res)) self.$f7.toast.create({ text: unwrapDto(res), position: 'top', closeTimeout: 2000 }).open();
          self.cargarPersonas();
        });
      }, function() {}, '1.06');
    },
    nuevosObjetivos() {
      var self = this;
      var destino = self.anio + 1;
      self.$f7.dialog.prompt('Año destino:', 'Copiar objetivos de ' + self.anio, function(anioStr) {
        var anioDest = parseInt(anioStr);
        if (isNaN(anioDest)) return;
        self.$f7.dialog.prompt('Factor a aplicar:', 'Factor', function(factorStr) {
          var factor = parseFloat(factorStr);
          if (isNaN(factor) || factor <= 0) return;
          Oeb.copiarObjetivos({ anioOrigen: self.anio, anioDestino: anioDest, factor: factor }).then(function(res) {
            if (unwrapDto(res)) self.$f7.toast.create({ text: unwrapDto(res), position: 'top', closeTimeout: 2000 }).open();
            self.anio = anioDest;
            self.cargarPersonas();
          });
        }, function() {}, '1.06');
      }, function() {}, destino + '');
    },
    migrarDesdeConfig() {
      var self = this;
      self.$f7.dialog.confirm('¿Migrar datos de config personas a objetivos ' + self.anio + '?', 'Migrar', function() {
        Oeb.migrarObjetivosDesdeConfig().then(function(res) {
          if (unwrapDto(res)) self.$f7.toast.create({ text: unwrapDto(res), position: 'top', closeTimeout: 2000 }).open();
          self.cargarPersonas();
        });
      });
    },
    formatImporte(valor) {
      if (valor == null) return '0 €';
      return Math.round(valor).toLocaleString('es-ES') + ' €';
    },
    // Instrucciones
    cargarInstrucciones() {
      var self = this;
      Oeb.getInstrucciones('configuracion').then(function(res) {
        self.instrucciones = (unwrapDto(res) || []).map(function(i) { i._editando = false; return i; });
      }).catch(function() {});
    },
    inicializarInst() {
      var self = this;
      Oeb.inicializarInstrucciones('configuracion').then(function() { self.cargarInstrucciones(); });
    },
    nuevaInst() {
      var self = this;
      Oeb.crearInstruccion({ pantalla: 'configuracion', titulo: 'Nueva instrucción', texto: 'Escribe aquí...', orden: self.instrucciones.length }).then(function(res) {
        if (unwrapDto(res)) { unwrapDto(res)._editando = true; self.instrucciones.push(unwrapDto(res)); self.expandedInst = unwrapDto(res).id; }
      });
    },
    guardarInst(inst) {
      var self = this;
      Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto }).then(function() {
        inst._editando = false;
        self.$f7.toast.create({ text: 'Instrucción guardada', position: 'top', closeTimeout: 2000 }).open();
      });
    },
    eliminarInst(inst) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        Oeb.eliminarInstruccion(inst.id).then(function() {
          self.instrucciones = self.instrucciones.filter(function(i) { return i.id !== inst.id; });
        });
      });
    },
    dropInst(idx) {
      var from = this.draggingInst;
      if (from === null || from === idx) return;
      var item = this.instrucciones.splice(from, 1)[0];
      this.instrucciones.splice(idx, 0, item);
      this.draggingInst = null;
      var ids = this.instrucciones.map(function(i) { return i.id; });
      Oeb.reordenarInstrucciones(ids);
    },
  }
};
</script>
